import { render, staticRenderFns } from "./editionpay_mobile.vue?vue&type=template&id=07fd1b83&scoped=true&"
import script from "./editionpay_mobile.vue?vue&type=script&lang=js&"
export * from "./editionpay_mobile.vue?vue&type=script&lang=js&"
import style0 from "./editionpay_mobile.vue?vue&type=style&index=0&id=07fd1b83&scoped=true&lang=scss&"
import style1 from "./editionpay_mobile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fd1b83",
  null
  
)

export default component.exports